export default __webpack_public_path__ + "static/media/RDO logo jpg.b1d4f59c.jpg";